import type { RebookLoadingScreenProps } from "@b2bportal/core-flights-rebook";
import { useI18nContext } from "@hopper-b2b/i18n";
import { LoadingScreenWithProgress } from "@hopper-b2b/ui";
import { getEnvVariables } from "@hopper-b2b/utilities";
import Briefcase from "../../../assets/client/briefcase-detail.svg";
import styles from "./RebookLoadingScreen.module.scss";

export const RebookLoadingScreen = ({
  isLoading,
}: RebookLoadingScreenProps) => {
  const { t } = useI18nContext();

  const loadingSteps = [
    {
      title: t("bookingFlight"),
      description: t("bookingFlightSubtitle"),
      image: Briefcase,
    },
  ];

  return (
    isLoading && (
      <div className={styles.RebookLoadingScreen}>
        <LoadingScreenWithProgress
          className="flight-search-loading-popup"
          loadingSteps={loadingSteps}
          loading={isLoading}
          averageLoadingTime={
            getEnvVariables("cartFulfillLoadingTime") as number
          }
        />
      </div>
    )
  );
};
